
<footer id="dk-footer" class="dk-footer">
    <div class="container">
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-4">
                <div class="dk-footer-box-info">
                    <a href="index.html" class="footer-logo">
                        <img src="https://cdn.pixabay.com/photo/2016/11/07/13/04/yoga-1805784_960_720.png" alt="footer_logo" class="img-fluid">
                    </a>
                    <p class="footer-info-text">
                       Keep your trust on our Master minds.
                    </p>
                    <div class="footer-social-link">
                        <h3>Follow us</h3>
                        <ul>
                            <li>
                                <a href="https://www.facebook.com/bricksnbeams/">
                                    <i class="fa fa-facebook"></i>
                                </a>
                            </li>
                            <li>
                                <a href="https://twitter.com/Bricksanbeams">
                                    <i class="fa fa-twitter"></i>
                                </a>
                            </li>
                            <li>
                                <a href="https://youtu.be/IXMp-Svua3M">
                                    <i class="fa fa-youtube"></i>
                                </a>
                            </li>
                            <!-- <li>
                                <a href="#">
                                    <i class="fa fa-linkedin"></i>
                                </a>
                            </li> -->
                            <li>
                                <a href="https://www.instagram.com/bricksnbeams/">
                                    <i class="fa fa-instagram"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <!-- End Social link -->
                </div>
                <!-- End Footer info -->
            </div>
            <!-- End Col -->
            <div class="col-sm-12 col-md-12 col-lg-8 contact-us-block">
                <div class="row">
                    <div class="col-md-6">
                        <div class="contact-us">
                            <div class="contact-icon">
                                <i class="fa fa-map-o" aria-hidden="true"></i>
                            </div>
                            <!-- End contact Icon -->
                            <div class="contact-info">
                                <h3>Chennai, India</h3>
                                <p>Tamil Nadu</p>
                            </div>
                            <!-- End Contact Info -->
                        </div>
                        <!-- End Contact Us -->
                    </div>
                    <!-- End Col -->
                    <div class="col-md-6">
                        <div class="contact-us contact-us-last">
                            <div class="contact-icon">
                                <i class="fa fa-volume-control-phone" aria-hidden="true"></i>
                            </div>
                            <!-- End contact Icon -->
                            <div class="contact-info">
                                <h3><a href="tel:+917338834435">73388 34435</a></h3>
                                <p>Give us a call</p>
                            </div>
                            <!-- End Contact Info -->
                        </div>
                        <!-- End Contact Us -->
                    </div>
                    <!-- End Col -->
                </div>
                <!-- End Contact Row -->
                <div class="row">
                    <div class="col-md-12 col-lg-6">
                        <div class="footer-widget footer-left-widget">
                            <div class="section-heading">
                                <h3>Useful Links</h3>
                                <span class="animate-border border-black"></span>
                            </div>
                            <ul>
                                <li>
                                    <a [routerLink]="['/home']" routerLinkActive="router-link-active" >Home</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/services']" routerLinkActive="router-link-active" >Services</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/design']" routerLinkActive="router-link-active" >Design Service</a>
                                </li>

                                <li>
                                    <a [routerLink]="['/construction']" routerLinkActive="router-link-active" >Construction & Engineering</a>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <a [routerLink]="['/about']" routerLinkActive="router-link-active" >About us</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/process']" routerLinkActive="router-link-active" >Process</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/gallery']" routerLinkActive="router-link-active" >Gallery</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/contact']" routerLinkActive="router-link-active" >Contact Us</a>
                                </li>
                            </ul>
                        </div>
                        <!-- End Footer Widget -->
                    </div>
                    <!-- End col -->
                    <div class="col-md-12 col-lg-6">
                        <div class="footer-widget">
                            <div class="section-heading">
                                <h3>Subscribe</h3>
                                <span class="animate-border border-black"></span>
                            </div>
                            <p><!-- Don’t miss to subscribe to our new feeds, kindly fill the form below. -->
                            Sign up to get the latest news and updates.</p>
                            <!-- <form> -->
                                <div class="form-row">
                                    <div class="col dk-footer-form">
                                        <input type="email" class="form-control" placeholder="Email Address" [(ngModel)]="email">
                                        <button type="submit" (click)="sendMail()">
                                            <i class="fa fa-send"></i>
                                        </button>
                                    </div>

                                </div>
                            <!-- </form> -->
                            <h4 *ngIf="status == 1" style="color: rgb(136, 35, 35);">Please enter a valid email.</h4>
                            <h4 *ngIf="status == 0" style="color: #fac67a">Thank you for subscribing!</h4>
                            <!-- End form -->
                        </div>
                        <!-- End footer widget -->
                    </div>
                    <!-- End Col -->
                </div>
                <!-- End Row -->
            </div>
            <!-- End Col -->
        </div>
        <!-- End Widget Row -->
    </div>
    <!-- End Contact Container -->


    <div class="copyright">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <span>Copyright © 2021, All Right Reserved</span>
                </div>
                <!-- End Col -->
                <div class="col-md-6">
                    <div class="copyright-menu">
                        <!-- <ul>
                            <li>
                                <a href="#">Home</a>
                            </li>
                            <li>
                                <a href="#">Terms</a>
                            </li>
                            <li>
                                <a href="#">Privacy Policy</a>
                            </li>
                            <li>
                                <a href="#">Contact</a>
                            </li>
                        </ul> -->
                    </div>
                </div>
                <!-- End col -->
            </div>
            <!-- End Row -->
        </div>
        <!-- End Copyright Container -->
    </div>
    <!-- End Copyright -->
    <!-- Back to top -->
    <!-- <div id="back-to-top" class="back-to-top">
        <button class="btn btn-dark" title="Back to Top" style="display: block;">
            <i class="fa fa-angle-up"></i>
        </button>
    </div> -->
    <!-- End Back to top -->
</footer>